import React from 'react'
import { buttonType } from '../utils/constants'

const index = ({ type, url, target, label, classStyles, iconClass }) => {
 let addedClasses = [];
  try {
   addedClasses = classStyles?.length > 0 ? classStyles: [];
  } catch (error) {
   
  }
  const buttonClass = ['btn', 'btn-sm', ...addedClasses].join(' ');
  switch (type) {
    case buttonType.LINK:
      return (
        <a
          type='button'
          href={url}
          target={target || '_blank'}
          className={buttonClass}
        >
          {iconClass && <i className={`${iconClass} me-1`}></i>} {label}
        </a>
      );

    // case buttonType.BUTTON:
    //  return (
    //    <a
    //      type='button'
    //      href={binary?.repository}
    //      target='_blank'
    //      className='btn btn-dark btn-sm p-2'
    //    >
    //      <i className='bi bi-github me-1'></i> GitHub Repository
    //    </a>
    //  );

    default:
      throw Error('invalid button type');
  }
};

export default index